export const MAX_SCHEDULED_RANGE_MONTHS = 3;
